import Vue from 'vue';
import Vuex from 'vuex';
// @ts-ignore
import VuexORM from './Store/VuexOrm';
// @ts-ignore
Vue.use(Vuex);
// @ts-ignore
import ModuleCore from '@/Store/ModuleCore';

export default new Vuex.Store({
  modules: ModuleCore,
  plugins: [VuexORM],
  state: {
    dymo: null,
    testing: Boolean(parseInt(process.env.VUE_APP_IS_TESTING)),
    snackBar: {
      show: false,
      delay: 5000,
      message: '',
      type: '',
      showLoading: false,
      loadingMessage: '',
      showNotification: false,
      notificationMessage: ''
    },
    notifications: {
      hidden_releases: 0,
    },
    filtered_flags: [],
    manifest_filtered_flags: [],
    filtered_test_types: [],
    user: {
      id: null,
      email: null,
      name: null,
      given_name: null,
      family_name: null,
      picture: null,
      keep_alive: true,
      ref: null,
      permissions: [],
      default_queries: []
    },
    customer: {},
    appOrigin: 'http://dir.conflabs.com',
    belitApi: {
      apiKey: process.env.VUE_APP_BELIT_API_KEY,
      apiVersionOne: process.env.VUE_APP_BELIT_API,
    },
    recordedApi: {
      apiKey: process.env.VUE_APP_RECORDED_API_KEY,
      apiVersionOne: process.env.VUE_APP_RECORDED_API,
    },
    traceApi: {
      apiKey: process.env.VUE_APP_TRACE_API_KEY,
      apiVersionOne: process.env.VUE_APP_TRACE_API,
    },
  },
  getters: {
    id: (state) => state.user.id,
    email: (state) => state.user.email,
    name: (state) => state.user.name,
    given_name: (state) => state.user.given_name,
    family_name: (state) => state.user.family_name,
    picture: (state) => state.user.picture,
    app_origin: (state) => state.appOrigin,
    belit_api: (state) => state.belitApi.apiVersionOne,
    belit_api_token: (state) => state.belitApi.apiKey,
    recorded_api: (state) => state.recordedApi.apiVersionOne,
    recorded_api_token: (state) => state.recordedApi.apiKey,
    trace_api: (state) => state.traceApi.apiVersionOne,
    trace_api_token: (state) => state.traceApi.apiKey,
  },
  mutations: {
    id(state, id) {
      state.user.id = id;
    },
    email(state, email) {
      state.user.email = email;
    },
    name(state, name) {
      state.user.name = name;
    },
    given_name(state, given_name) {
      state.user.given_name = given_name;
    },
    family_name(state, family_name) {
      state.user.family_name = family_name;
    },
    picture(state, picture) {
      state.user.picture = picture;
    },
    showError(state, message) {
      state.snackBar.show = true;
      state.snackBar.message = message;
      state.snackBar.type = 'error';
    },
    showSuccess(state, message) {
      state.snackBar.show = true;
      state.snackBar.message = message;
      state.snackBar.type = 'success';
    },
    resetSnackBar(state) {
      state.snackBar.show = false;
      state.snackBar.delay = 5000;
      state.snackBar.message = '';
      state.snackBar.type = '';
    },
    showLoading(state, message){
      state.snackBar.showLoading = true;
      state.snackBar.loadingMessage = message;
    },
    resetLoadingSnackBar(state){
      state.snackBar.showLoading = false;
      state.snackBar.loadingMessage = '';
    },
    setFilteredFlags(state, flags){
      state.filtered_flags = flags || [];
      state.manifest_filtered_flags = flags || [];
    },
    setManifestFilteredFlags(state, flags){
      state.filtered_flags = flags || [];
      state.manifest_filtered_flags = flags || [];
    },
    setFilteredTestTypes(state, testTypes){
      state.filtered_test_types = testTypes || [];
    },
    setupUser(state, fb){
      state.user.ref = fb.ref;
      let data = fb.data();
      if(data.default_queries){
        state.user.default_queries = data.default_queries;
      }
      if(data.belit_permisions){
        state.user.permissions = data.belit_permissions;
      }
    },
    setHiddenReleases(state, count){
      state.notifications.hidden_releases = count;
    }
  },
  actions: {
    showLoading({ commit }, message){
      commit('showLoading', message);
    },
    resetLoading({commit}){
      commit('resetLoadingSnackBar');
    },
    showError({ commit }, message) {
      commit('showError', message);
    },
    showSuccess({ commit }, message) {
      commit('showSuccess', message);
    },
    async getHiddenReleases({commit}){
      // @ts-ignore
      let query = await this.$db().model('reportedSamples').api().fetch({
        aggregate: 'count',
        where: [
          {key: 'hidden', value: true}
        ]
      });
      commit('setHiddenReleases', query.response.data);
    }
  },
});
